import { Outlet, useLocation } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TablePagination from "@mui/material/TablePagination";
import { flexRender } from "@tanstack/react-table";
import {
  AppTable,
  AppTableBody,
  AppTableCell,
  AppTableContainer,
  AppTableHead,
  AppTableRow,
  AppTableSort,
} from "../../../../../../components/common/app-table/ui";
import useDefaultTable from "../../../../../../components/common/app-table/useDefaultTable";
import { useEJOESRApprovalContext } from "../../Context/EJOESRApprovalContext";
import React, { useEffect, useState } from "react";
import { ESRManpowerColumns } from "./utils/types";
import { Button, Typography } from "@mui/material";
import { useCreateESRManpowerColumns } from "../hooks/useCreateESRManpowerColumns";
import { useESRApprovalContext } from "../../Context/ESRApprovalContext";
import { Add } from "@mui/icons-material";
import DeleteConfirmDialog from "../DeleteConfirmDialog";

const ESRManpowerTable = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const [isDeletionConfirmed, setIsDeletionConfirmed] =
    useState<boolean>(false);

  const {
    setOpenManhourDialog,
    setMhActionType,
    esrManpowerArray,
    setEsrManpowerArray,
    currentManhourSelected,
    setCurrentManhourSelected,
    openMhDeleteDialog,
    setOpenMhDeleteDialog,
  } = useESRApprovalContext();
  const esrManpowerColumns = useCreateESRManpowerColumns();

  const { table, dataCount, pageIndex, pageSize } =
    useDefaultTable<ESRManpowerColumns>(esrManpowerArray, esrManpowerColumns);

  // TODO CHANGE TO MANPOWER
  const goToAddMH = () => {
    setMhActionType("new");
    setCurrentManhourSelected({
      id: "",
      manHours: 0,
      mechanicId: "",
      mechanicName: "",
    });
    setOpenManhourDialog(true);
  };

  useEffect(() => {
    if (isDeletionConfirmed) {
      const newArray = esrManpowerArray.filter(
        (sr, index) => String(index) != currentManhourSelected.id
      );
      setEsrManpowerArray(newArray);
      setIsDeletionConfirmed(false);
    }
  }, [isDeletionConfirmed]);

  return (
    <>
      <Stack direction="column" mb={2} mt={5} gap={3}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h6" component="div">
            Manpower & Man Hours
          </Typography>
          {(pathSegments[2] == "create" ||
            pathSegments[2] == "edit" ||
            pathSegments[2] == "start" ||
            pathSegments[2] == "complete") && (
            <Button
              disableElevation
              sx={{
                textTransform: "capitalize",
                fontSize: "9pt",
                bgcolor: "primary",
                color: "white",
                padding: 0.75,
                paddingX: 2.5,
                minWidth: "auto",
                borderRadius: "3px",
                "&:hover": {
                  bgcolor: "primary",
                },
              }}
              onClick={() => goToAddMH()}
            >
              <Add fontSize="medium" />
            </Button>
          )}
        </Stack>
      </Stack>
      <Paper elevation={3}>
        <AppTableContainer>
          <AppTable stickyHeader>
            <AppTableHead>
              {table.getHeaderGroups().map((headerGroup) => (
                <AppTableRow key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <AppTableCell key={header.id} align="center">
                      <AppTableSort
                        canSort={header.column.getCanSort()}
                        currentSort={header.column.getIsSorted()}
                        onSort={header.column.getToggleSortingHandler()}
                      >
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                      </AppTableSort>
                    </AppTableCell>
                  ))}
                </AppTableRow>
              ))}
            </AppTableHead>
            <AppTableBody dataCount={dataCount}>
              {table.getRowModel().rows.map((row) => (
                <AppTableRow key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <AppTableCell
                      key={cell.id}
                      align="center"
                      style={{
                        padding:
                          pathSegments[2] == "create" ||
                          pathSegments[2] == "edit" ||
                          pathSegments[2] == "start" ||
                          pathSegments[2] == "complete"
                            ? undefined
                            : "12px",
                      }}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </AppTableCell>
                  ))}
                </AppTableRow>
              ))}
            </AppTableBody>
          </AppTable>
        </AppTableContainer>
        <Box position="relative">
          <TablePagination
            sx={{ bgcolor: "white", borderTop: "1px solid #eee" }}
            component="div"
            count={dataCount}
            page={pageIndex}
            onPageChange={(e, page) => table.setPageIndex(page)}
            rowsPerPage={pageSize}
            onRowsPerPageChange={(e) =>
              table.setPageSize(Number(e.target.value))
            }
            rowsPerPageOptions={[10, 20, 50, 100]}
          />
        </Box>
      </Paper>
      <Outlet />
      <DeleteConfirmDialog
        openDeleteDialog={openMhDeleteDialog}
        setOpenDeleteDialog={setOpenMhDeleteDialog}
        setIsDeletionConfirmed={setIsDeletionConfirmed}
        type="manpower"
      />
    </>
  );
};

export default React.memo(ESRManpowerTable);
